<section class="cloud-infrastructure-hero">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="hero-content">
                    <span class="hero-badge">Meet Our Expert Team</span>
                    <h1 class="hero-title">Cloud Infrastructure Specialists</h1>
                    <p class="hero-description">Our dedicated team of cloud engineers, architects, and infrastructure specialists brings cutting-edge expertise in NVIDIA GPU computing, AI/ML platforms, and enterprise cloud solutions to accelerate your digital transformation.</p>
                    
                    <div class="team-stats">
                        <div class="stat-item">
                            <div class="stat-number">15+</div>
                            <div class="stat-label">Expert Engineers</div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-number">50+</div>
                            <div class="stat-label">Certifications</div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-number">24/7</div>
                            <div class="stat-label">Support Coverage</div>
                        </div>
                    </div>
                    
                    <div class="hero-actions">
                        <a class="btn-primary-gradient" routerLink="/contact">
                            <i class="bx bx-phone"></i>
                            Contact Our Team
                        </a>
                        <a class="btn-outline-light" routerLink="/careers">
                            <i class="bx bx-briefcase"></i>
                            Join Our Team
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="hero-image">
                    <div class="image-decoration">
                        <div class="floating-card card-1">
                            <i class="bx bx-certification"></i>
                            <span>AWS Certified</span>
                        </div>
                        <div class="floating-card card-2">
                            <i class="bx bx-trophy"></i>
                            <span>Industry Leaders</span>
                        </div>
                        <div class="floating-card card-3">
                            <i class="bx bx-support"></i>
                            <span>24/7 Expertise</span>
                        </div>
                    </div>
                    <img src="assets/img/solutions-img.png" alt="Cloud Infrastructure Team" class="img-fluid main-image">
                </div>
            </div>
        </div>
    </div>
    <div class="hero-background-elements">
        <div class="bg-element element-1"></div>
        <div class="bg-element element-2"></div>
        <div class="bg-element element-3"></div>
    </div>
</section>

<!-- Leadership Team Section -->
<section class="leadership-team-section ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="section-badge">Leadership Team</span>
            <h2>Meet Our <span class="text-highlight">Cloud Infrastructure Leaders</span></h2>
            <p>Experienced professionals leading our cloud infrastructure initiatives with expertise in GPU computing, AI/ML platforms, and enterprise-grade solutions.</p>
        </div>
        
        <div class="row">
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="team-card leadership">
                    <div class="team-image">
                        <img src="assets/img/team/team-img-one.png" alt="Rajesh Kumar">
                        <div class="team-overlay">
                            <div class="social-links">
                                <a href="#" target="_blank"><i class="bx bxl-linkedin"></i></a>
                                <a href="#" target="_blank"><i class="bx bxl-twitter"></i></a>
                                <a href="mailto:rajesh@insightfulitservices.com"><i class="bx bx-envelope"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="team-content">
                        <h3>Rajesh Kumar</h3>
                        <div class="team-role">Chief Technology Officer</div>
                        <div class="team-expertise">
                            <span class="expertise-tag">Cloud Architecture</span>
                            <span class="expertise-tag">NVIDIA GPU</span>
                            <span class="expertise-tag">AI/ML Platforms</span>
                        </div>
                        <p class="team-bio">15+ years in cloud infrastructure with expertise in GPU computing and AI/ML platform development. Led digital transformation for 200+ enterprises.</p>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="team-card leadership">
                    <div class="team-image">
                        <img src="assets/img/team/team-img-two.png" alt="Priya Sharma">
                        <div class="team-overlay">
                            <div class="social-links">
                                <a href="#" target="_blank"><i class="bx bxl-linkedin"></i></a>
                                <a href="#" target="_blank"><i class="bx bxl-twitter"></i></a>
                                <a href="mailto:priya@insightfulitservices.com"><i class="bx bx-envelope"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="team-content">
                        <h3>Priya Sharma</h3>
                        <div class="team-role">VP of Cloud Operations</div>
                        <div class="team-expertise">
                            <span class="expertise-tag">Operations Management</span>
                            <span class="expertise-tag">Cloud Security</span>
                            <span class="expertise-tag">DevOps</span>
                        </div>
                        <p class="team-bio">Expert in large-scale cloud operations and security with AWS, Azure, and Google Cloud certifications. Manages 24/7 operations for 500+ cloud instances.</p>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="team-card leadership">
                    <div class="team-image">
                        <img src="assets/img/team/team-img-three.png" alt="Amit Singh">
                        <div class="team-overlay">
                            <div class="social-links">
                                <a href="#" target="_blank"><i class="bx bxl-linkedin"></i></a>
                                <a href="#" target="_blank"><i class="bx bxl-twitter"></i></a>
                                <a href="mailto:amit@insightfulitservices.com"><i class="bx bx-envelope"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="team-content">
                        <h3>Amit Singh</h3>
                        <div class="team-role">Head of GPU Computing</div>
                        <div class="team-expertise">
                            <span class="expertise-tag">NVIDIA H200/H100</span>
                            <span class="expertise-tag">CUDA Programming</span>
                            <span class="expertise-tag">HPC</span>
                        </div>
                        <p class="team-bio">Specialist in NVIDIA GPU architectures and high-performance computing. Architected GPU clusters serving 100+ AI/ML research projects.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Technical Team Section -->
<section class="technical-team-section ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="section-badge">Technical Specialists</span>
            <h2>Expert <span class="text-highlight">Cloud Engineers</span></h2>
            <p>Our technical team specializes in cloud infrastructure deployment, GPU computing, and 24/7 operations management across Mumbai and Noida data centers.</p>
        </div>
        
        <div class="row">
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="team-card technical">
                    <div class="team-image">
                        <img src="assets/img/team/team-img-four.png" alt="Neha Patel">
                        <div class="certification-badge">
                            <i class="bx bx-certification"></i>
                            <span>AWS Certified</span>
                        </div>
                    </div>
                    <div class="team-content">
                        <h4>Neha Patel</h4>
                        <div class="team-role">Cloud Migration Architect</div>
                        <div class="team-expertise">
                            <span class="expertise-tag">AWS Migration</span>
                            <span class="expertise-tag">Kubernetes</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="team-card technical">
                    <div class="team-image">
                        <img src="assets/img/team/team-img-five.png" alt="Vikram Gupta">
                        <div class="certification-badge">
                            <i class="bx bx-network-chart"></i>
                            <span>Network Expert</span>
                        </div>
                    </div>
                    <div class="team-content">
                        <h4>Vikram Gupta</h4>
                        <div class="team-role">Network Infrastructure Lead</div>
                        <div class="team-expertise">
                            <span class="expertise-tag">Load Balancers</span>
                            <span class="expertise-tag">DDoS Protection</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="team-card technical">
                    <div class="team-image">
                        <img src="assets/img/team/team-img-six.png" alt="Sunita Rao">
                        <div class="certification-badge">
                            <i class="bx bx-data"></i>
                            <span>Data Specialist</span>
                        </div>
                    </div>
                    <div class="team-content">
                        <h4>Sunita Rao</h4>
                        <div class="team-role">Backup & Recovery Engineer</div>
                        <div class="team-expertise">
                            <span class="expertise-tag">Disaster Recovery</span>
                            <span class="expertise-tag">NVMe Storage</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="team-card technical">
                    <div class="team-image">
                        <img src="assets/img/team/team-img-seven.png" alt="Arjun Mehta">
                        <div class="certification-badge">
                            <i class="bx bx-shield-check"></i>
                            <span>Security Expert</span>
                        </div>
                    </div>
                    <div class="team-content">
                        <h4>Arjun Mehta</h4>
                        <div class="team-role">Cloud Security Engineer</div>
                        <div class="team-expertise">
                            <span class="expertise-tag">ISO 27001</span>
                            <span class="expertise-tag">SOC 2</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="team-card technical">
                    <div class="team-image">
                        <img src="assets/img/team/team-img-eight.png" alt="Kavya Joshi">
                        <div class="certification-badge">
                            <i class="bx bx-cog"></i>
                            <span>Operations</span>
                        </div>
                    </div>
                    <div class="team-content">
                        <h4>Kavya Joshi</h4>
                        <div class="team-role">Cloud Operations Manager</div>
                        <div class="team-expertise">
                            <span class="expertise-tag">24/7 Monitoring</span>
                            <span class="expertise-tag">DevOps</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="team-card technical">
                    <div class="team-image">
                        <img src="assets/img/team/team-img-nine.jpg" alt="Rohit Agarwal">
                        <div class="certification-badge">
                            <i class="bx bx-chip"></i>
                            <span>GPU Expert</span>
                        </div>
                    </div>
                    <div class="team-content">
                        <h4>Rohit Agarwal</h4>
                        <div class="team-role">GPU Solutions Specialist</div>
                        <div class="team-expertise">
                            <span class="expertise-tag">NVIDIA H200</span>
                            <span class="expertise-tag">AI/ML</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="team-card technical">
                    <div class="team-image">
                        <img src="assets/img/team/team-img-ten.jpg" alt="Sanjay Verma">
                        <div class="certification-badge">
                            <i class="bx bxl-docker"></i>
                            <span>DevOps</span>
                        </div>
                    </div>
                    <div class="team-content">
                        <h4>Sanjay Verma</h4>
                        <div class="team-role">Cloud DevOps Engineer</div>
                        <div class="team-expertise">
                            <span class="expertise-tag">Docker</span>
                            <span class="expertise-tag">Terraform</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="team-card technical">
                    <div class="team-image">
                        <img src="assets/img/team/team-img-eleven.jpg" alt="Deepika Thakur">
                        <div class="certification-badge">
                            <i class="bx bx-trending-up"></i>
                            <span>Analytics</span>
                        </div>
                    </div>
                    <div class="team-content">
                        <h4>Deepika Thakur</h4>
                        <div class="team-role">Infrastructure Analyst</div>
                        <div class="team-expertise">
                            <span class="expertise-tag">Performance</span>
                            <span class="expertise-tag">Monitoring</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- CTA Section -->
<section class="team-cta-section ptb-100">
    <div class="container">
        <div class="cta-content-wrapper">
            <div class="row align-items-center">
                <div class="col-lg-8">
                    <div class="cta-content">
                        <h2>Join Our World-Class Team</h2>
                        <p class="cta-description">Be part of India's leading cloud infrastructure team. We're always looking for talented engineers, architects, and specialists to join our growing team in Mumbai and Noida.</p>
                        
                        <div class="cta-features">
                            <div class="feature-item">
                                <i class="bx bx-award"></i>
                                <span>Industry-leading benefits</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-book-open"></i>
                                <span>Continuous learning opportunities</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-trending-up"></i>
                                <span>Career growth & development</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="cta-actions">
                        <a class="btn-cta-primary" routerLink="/careers">
                            <i class="bx bx-briefcase"></i>
                            <span>View Open Positions</span>
                            <small>Join our team today</small>
                        </a>
                        <a class="btn-cta-secondary" routerLink="/contact">
                            <i class="bx bx-envelope"></i>
                            <span>Contact HR Team</span>
                            <small>careers@insightfulitservices.com</small>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="cta-background-elements">
        <div class="bg-element element-1"></div>
        <div class="bg-element element-2"></div>
        <div class="bg-element element-3"></div>
        <div class="bg-element element-4"></div>
    </div>
</section>